<template>
  <div>
    <RegisterForm :method="userdata" />
    <v-card>
      <v-data-table
        :headers="headers"
        :items="listItems"
        :loading="loading"
        :server-items-length="totalItems"
        :options.sync="options"
      >
        <template v-slot:item.action="{ item }">
          <v-btn text @click="deleteItem(item)" color="red">
            <v-icon small>delete</v-icon> Delete
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/api";
import RegisterForm from "@/components/register/RegisterForm.vue";
export default {
  name: "BookingList",
  components: {
    RegisterForm,
  },
  data: () => ({
    loading: false,
    dialog: false,
    options: {},
    headers: [
      { text: "Name", value: "name" },
      { text: "Email", value: "email" },
      { text: "Role", value: "role" },
      { text: "Actions", value: "action", sortable: false },
    ],
    itemHeaders: [
      {
        text: "#",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Name", value: "name" },
      { text: "Email", value: "email" },
      { text: "Role", value: "role" },
    ],
    listItems: [],
    sending: false,
    totalItems: 0,
    activeItem: null,
  }),
  watch: {
    options: {
      handler() {
        this.userdata();
      },
      deep: true,
    },
  },
  methods: {
    async userdata() {
      const { page = 1, itemsPerPage = 10 } = this.options;
      this.loading = true;
      const response = await api.usersdata(itemsPerPage, page);
      // console.log(response);
      this.totalItems = response.data.count;
      this.listItems = response.data;
      this.loading = false;
    },
    async deleteItem(item) {
      const confirm = await this.$alert.confirm(
        `Delete Broadcast List #${item.id} ?`
      );
      if (confirm && confirm.value === true) {
        try {
          await api.userdelete([item.id]);
          this.$toast.success("Deleted Successfully");
          this.userdata();
        } catch (error) {
          this.$toast.error("Error Deleting");
        }
      }
    },
  },
};
</script>